import { AccessRightsFeature, AccessRightsGroup, Feature } from './AccessRights';

export const createAccessRightID = (resourceID: number, featureID: number) => resourceID * 10000 + featureID;

/** Convert string into more human readable form */
export function convertAccessRightID2Description(accessRightID: number, groups: AccessRightsGroup[], features: AccessRightsFeature[]) {
  let resourceID = Math.floor(accessRightID / 10000);
  let featureID = accessRightID - resourceID * 10000;
  for (const group of groups) {
    for (const resource of group.resources) {
      if (resource.resourceID == resourceID) {
        let feature = features.find((f) => f.featureID == featureID);
        if (feature) return { resource, feature };
      }
    }
  }
  return null;
}

// NOTE! Stupid that we have to give the groups and features, framework should know about these all the time
export function convertAccessRightID2DescriptionConstantName(
  accessRightID: number,
  groups: AccessRightsGroup[],
  features: AccessRightsFeature[]
) {
  let d = convertAccessRightID2Description(accessRightID, groups, features);
  if (!d) return 'error';
  return d.resource.constant + (d.feature.featureID != Feature.ENABLE ? '.' + d.feature.constant : '');
}

export function verifyAccessRights(groups: AccessRightsGroup[], features: AccessRightsFeature[], AccessRights: { [key: string]: number }) {
  const featureById: { [featureID: number]: AccessRightsFeature } = {};
  const result: { [constantName: string]: number } = {};
  const seenIDs: { [accessRightID: number]: 1 } = {};

  // Create AccessRights.featureById
  for (const feature of features) {
    featureById[feature.featureID] = feature;
  }

  // Create AccessRights.[RESOURCECONSTANT_FEATURECONSTANT], NOTE! For enabled only [RESOURCECONSTANT]
  let constantError = false;
  for (const group of groups) {
    for (const resource of group.resources) {
      for (const featureID of resource.features) {
        let accessRightID = createAccessRightID(resource.resourceID, featureID);
        let constantName = featureID == Feature.ENABLE ? resource.constant : resource.constant + '_' + featureById[featureID].constant;
        if (seenIDs[accessRightID]) {
          console.log('WARNING! Same access right id used twice, please fix! ');
          console.log(constantName, resource);
          process.exit();
        }
        seenIDs[accessRightID] = 1;
        result[constantName] = accessRightID;

        if (!AccessRights[constantName] || AccessRights[constantName] !== accessRightID) {
          constantError = true; // Some constant was wrong or missing, NOTE! We want find extra constants
        }
        //result.accessRightIDs[accessRightID] = { resource: resource, feature: result.featureById[featureID] };
      }
    }
  }

  if (Object.entries(result).length != Object.entries(AccessRights).length) constantError = true;

  // Give notice if there is something wrong with the user access rights constants and kill the server
  if (constantError) {
    console.log('--------------------------------------------------------------------------------------------');
    console.log('ACCESS RIGHTS HAS CHANGES, PLEASE PASTE THIS INTO THE APPROPRIATE SECTION IN AccessRights.ts');
    console.log('--------------------------------------------------------------------------------------------');
    console.log();
    Object.entries(result).map(([key, value]) => console.log('  ' + key + ': ' + value + ','));
    console.log();
    console.log('--------------------------------------------------------------------------------------------');
    console.log('ACCESS RIGHTS HAS CHANGES, PLEASE PASTE THIS INTO THE APPROPRIATE SECTION IN AccessRights.ts');
    console.log('--------------------------------------------------------------------------------------------');
    process.exit();
  }
}
